import "core-js/modules/es.number.constructor.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "edu-accept-records"
};
var _hoisted_2 = {
  class: "week-body"
};
var _hoisted_3 = {
  class: "list-body"
};
var _hoisted_4 = {
  class: "type-icon-item"
};
var _hoisted_5 = {
  class: "num"
};
var _hoisted_6 = {
  class: "type-icon-item"
};
var _hoisted_7 = {
  class: "num"
};
var _hoisted_8 = {
  class: "type-icon-item"
};
var _hoisted_9 = {
  class: "num"
};
import { ref, watch } from 'vue';
import { isNullValue } from '../utils';
export default {
  __name: 'AcceptRecords',
  props: {
    weeks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['weekMore'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var excellentNum = ref(0);
    var qualifiedNum = ref(0);
    var unqualifiedNum = ref(0);

    /**
     * 初始化统计
     */
    var initCount = function initCount(list) {
      for (var index = 0; index < list.length; index++) {
        var _list$index = list[index],
          grade = _list$index.grade,
          count = _list$index.count;
        if (Number(grade) === 1) excellentNum.value = count;
        if (Number(grade) === 2) qualifiedNum.value = count;
        if (Number(grade) === 3) unqualifiedNum.value = count;
      }
    };
    watch(function () {
      return props.weeks;
    }, function (list) {
      if (isNullValue(list)) return;
      initCount(list);
    }, {
      immediate: true,
      deep: true
    });

    /**
     * 本周更多
     */
    var weekMoreEvent = function weekMoreEvent() {
      emit('weekMore');
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_svg_icon, {
        name: "face-excellent",
        class: "type-icon",
        size: "24"
      }), _createElementVNode("span", _hoisted_5, "X" + _toDisplayString(excellentNum.value), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
        name: "face-qualified",
        class: "type-icon",
        size: "24"
      }), _createElementVNode("span", _hoisted_7, "X" + _toDisplayString(qualifiedNum.value), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_svg_icon, {
        name: "face-unqualified",
        class: "type-icon",
        size: "24"
      }), _createElementVNode("span", _hoisted_9, "X" + _toDisplayString(unqualifiedNum.value), 1)])]), _createVNode(_component_t_button, {
        class: "btn-arrow",
        shape: "circle",
        variant: "text",
        onClick: weekMoreEvent
      }, {
        icon: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            name: "arrow-right"
          })];
        }),
        _: 1
      })])]);
    };
  }
};